import React, { useState, useEffect } from 'react';
import { Redirect, useLocation, useHistory} from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import LogoutIcon from '@mui/icons-material/Logout';

import Stack from '@mui/material/Stack';


import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, logout } from "./firebase";

import LoggedInUser from './LoggedInUser';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import {styled} from "@mui/system";

import AsyncStorage from '@react-native-async-storage/async-storage';

import { useTheme, useMediaQuery } from '@material-ui/core';


export default function ButtonAppBar(props) {
  const theme = useTheme();
  const isMD = useMediaQuery(theme.breakpoints.down('md'));
  const [signed_in_user, loading, error] = useAuthState(auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = useState(null);
  const open = Boolean(anchorEl);
  const [menuClient, setMenuClient] = React.useState(null);
  const openClient = Boolean(menuClient);
  const [menuUser, setMenuUser] = React.useState(null);
  const openUser = Boolean(menuUser);

  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
    
  const handleClickClient = (event) => {
    setMenuClient(event.currentTarget);
  };
  const handleCloseClient = () => {
    setMenuClient(null);
  };

  const handleClickUser = (event) => {
    setMenuUser(event.currentTarget);
  };
  const handleCloseUser = () => {
    setMenuUser(null);
  };

  const showDevices = () => {
    history.push(
        { 
          pathname: '/devices',
        });
  }

  const showClients = () => {
    history.push(
        { 
          pathname: '/clients',
        });
  }

  const showDashboard = () => {
    history.push(
        { 
          pathname: '/dashboard',
        });
  }

  const showAdminTools = () => {
    history.push(
        { 
          pathname: '/admintools',
        });
  }

  const history = useHistory();
  // handle click event of logout button
  const handleLogout = () => {
    window.location.href="/";
      logout();
    }

  const location = useLocation();

  useEffect(() => {
    if(!loading && !signed_in_user)
    {
      history.push("/");
    }
    if(signed_in_user && !loading)
    {
      //sessionStorage.setItem("uid", signed_in_user.uid);
      sessionStorage.setItem("photoURL", signed_in_user.photoURL);
      sessionStorage.setItem("displayName", signed_in_user.displayName);
      sessionStorage.setItem("email", signed_in_user.email);
      const storeData = async () => {
        const firstPair = ["@uid", signed_in_user.uid];
        const secondPair = ["@photoURL", signed_in_user.photoURL];
        const thirdPair = ["@displayName", signed_in_user.displayName];
        const forthPair = ["@email", signed_in_user.email];
        try {
          await AsyncStorage.multiSet([firstPair, secondPair, thirdPair, forthPair])
        } catch(e) {
          //save error
        }
        console.log("Appbar storage done.")
      }
      storeData();
    }
  }, [signed_in_user, loading]);

  if(loading)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Fetching user data...
              </Typography>
            </Box>
            </div>);
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" style={{ margin: 0}} enableColorOnDark>
        <Toolbar variant='regular'>
          <IconButton
            size="medium"
            edge="start" 
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={showDashboard}
          >
            <DashboardIcon />
          </IconButton>
          
          <Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            color="inherit"
            aria-expanded={open ? 'true' : undefined}
            sx={{ pr: 3}}
            onClick={showDevices}>
            Devices
            </Button>
          <Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            color="inherit"
            aria-expanded={open ? 'true' : undefined}
            sx={{ pr: 3}}
            onClick={showClients}>
            Clients
          </Button>
          <Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            color="inherit"
            aria-expanded={open ? 'true' : undefined}
            sx={{ pr: 3}}
            onClick={showAdminTools}>
            Admin Tools
          </Button>
          
          {/*<Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            color="inherit"
            aria-expanded={open ? 'true' : undefined}
            sx={{ pr: 3}}
            onClick={handleClickUser}>
            Users
            </Button>
          <Menu
            id="basic-menu"
            anchorEl={menuUser}
            open={openUser}
            onClose={handleCloseUser}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          > 
            <MenuItem onClick={handleCloseUser}><Link href="/users" underline="none">Show All Users</Link></MenuItem>
          </Menu>*/}
            <Typography color="inherit" component="div" sx={{ flexGrow: 1 }} justify="flex-end">
            </Typography>
          <Box
            sx={{
            display: 'flex',
            flexDirection: 'row',

            p: 1,
            m: 1,
            }}
            >
          <Typography color="inherit" component="div" sx={{ flexGrow: 1 }} justify="flex-end">
            {/*
            {signed_in_user ? <Stack direction="row" spacing={1} alignItems="center"><LoggedInUser uid={signed_in_user.uid} email={signed_in_user.email} displayName={signed_in_user.displayName} /> <IconButton onClick={handleLogout} ><LogoutIcon sx={{color: "white"}}/></IconButton></Stack>: <div />}
          */}
          {signed_in_user ? <Stack direction="row" spacing={1} alignItems="center">{isMD ? <Avatar>{signed_in_user.displayName.charAt(0)}</Avatar> : signed_in_user.email} <IconButton onClick={handleLogout} ><LogoutIcon sx={{color: "white"}}/></IconButton></Stack>: <div />}
          </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      
    </Box>
  );
}
